const NewsArchiveView = Barba.BaseView.extend({
    namespace: 'news-archive',

    onEnter: function() {
        new MainMenu(this.container);
        new InViewAnimation();
        new SearchModal(this.container);
        
        setIframeAspectRatios(this.container);
    }
});

NewsArchiveView.init();